import Train from './train.js';

let Facebook = {}

//let testId = '1730314430524109';
let id = '1730303503858535';  

window.fbAsyncInit = () => {
  window.FB.init({     
    appId      : id,
    xfbml      : true,
    version    : 'v2.5'
  });
};

let loadSDK = () => {
  let tag = document.createElement('script');
  tag.src = "//connect.facebook.net/en_US/sdk.js";
  let firstScriptTag = document.getElementsByTagName('script')[0];
  firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
};

loadSDK();

Facebook.signup = (accessToken) => {
  return Train.facebookSignup({accessToken})
};



module.exports = Facebook



// WEBPACK FOOTER //
// ./src/js/services/facebook.js